import React from 'react';
import { Loading } from '$ui/Integrations/Workflows/Loading';
import { DentallyManage } from '$ui/Integrations/Workflows/Dentally/DentallyManage';
import { DentallyRepair } from '$ui/Integrations/Workflows/Dentally/DentallyRepair';
import { DentallySetup } from '$ui/Integrations/Workflows/Dentally/DentallySetup';
import { useWorkflowSwitch } from '$ui/Integrations/Workflows/workflows';

export const ConnectedDentally = () => {
    const { integration, loadingStatus, commonProps } =
        useWorkflowSwitch('dentally');

    if (loadingStatus !== 'loaded') {
        return (
            <Loading integration="Dentally" onFinish={commonProps.onFinish} />
        );
    }

    if (integration.state === 'healthy') {
        return <DentallyManage {...commonProps} />;
    }

    if (integration.state === 'unhealthy') {
        return <DentallyRepair {...commonProps} />;
    }

    return <DentallySetup {...commonProps} />;
};

export * from './DentallyManage';
export * from './DentallyRepair';
export * from './DentallySetup';
